// ======================================================================
// File Name       : TreeWithDropdownControl
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import 'jstree/dist/jstree';
import 'jstree/dist/themes/default/style.css';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { DEV_MODE } from '../constants';

import AddIcon from '../images/tree/Add-24.png';
import DetailInfoIcon from '../images/tree/basic_info-24.png';
import RemoveIcon from '../images/tree/cancel_circle-24.png';
import DocumentIcon from '../images/tree/document-24.png';
import LinkIcon from '../images/tree/link.png';
import VideoIcon from '../images/tree/video-alt-24.png';
import { escapeHtml } from '../utils/index';

global.jQuery = require('jquery');
require('bootstrap');

const Icon = {
  Detail: DetailInfoIcon,
  Delete: RemoveIcon,
  New: AddIcon,
  Video: VideoIcon,
  Document: DocumentIcon,
  Link: LinkIcon,
};

const propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      text: PropTypes.any,
      icon: PropTypes.any,
      data: PropTypes.shape({
        menu: PropTypes.arrayOf(
          PropTypes.shape({
            icon: PropTypes.string,
            onClick: PropTypes.func,
          }),
        ),
      }),
      children: PropTypes.array,
    }),
  ).isRequired,
  openAll: PropTypes.bool,
  onChange: PropTypes.func,
  onOpenNode: PropTypes.func,
  onCloseNode: PropTypes.func,
  onSelectNode: PropTypes.func,
  searchOnCondition: PropTypes.func,
  onSelectCheckbox: PropTypes.func,
};

const defaultProps = {
  openAll: false,
  onChange: () => false,
  onOpenNode: () => false,
  onCloseNode: () => false,
  onSelectNode: () => false,
  searchOnCondition: () => false,
  onSelectCheckbox: () => false,
};

const Loading = 'loading';

const supportTouch = 'ontouchstart' in window;
const touchStartEvent = supportTouch ? 'touchstart' : 'mousedown';
const touchEndEvent = supportTouch ? 'touchend' : 'mouseup';

const numberMatch = 0;
const renderStart = 0;
/**
 * TreeView
 * Draw data by tree
 *
 * @class TreeView
 * @extends {Component}
 */
class TreeView extends Component {
  /**
     * TreeView props
     * @property {object}    data               - Data displayed in tree
     * @property {function}  onChange           - Optional. Callback function when tree change
     * @property {function}  onOpenNode         - Optional. Callback function before open node
     * @property {function}  onCloseNode        - Optional. Callback function before close node
     * @property {function}  searchOnCondition  - Optional. Callback function for search condition
     * @static
     */
  static propTypes = propTypes;

  /**
     * Default props
     *
     * @static
     */
  static defaultProps = defaultProps;

  /**
     * Default icon
     *
     * @static
     */
  static Icon = Icon;

  static Loading = Loading;

  /**
     * Search data in tree with filterData
     * Add prop searchOnCondition to determine tryly condition
     *
     * @param {any} filterData
     */
  search(filterData) {
    this.hasBeenClosed = false;
    if (filterData) {
      if (DEV_MODE) {
        this.numberMatch = 0;
        this.renderStart = new Date().getTime();
        console.log('Start Search');
      }
      $(this.tree).jstree(true).search(filterData);
    }
  }

  clearSearch() {
    $(this.tree).jstree(true).clear_search();
  }

  clearSearchAndCloseAll() {
    this.clearSearch();
    this.closeAll();
  }

  clearSearchAndOpenAll() {
    this.hasBeenClosed = false;
    this.clearSearch();
    this.openAll();
  }

  closeAll() {
    $(this.tree).jstree(true).close_all();
  }

  openAll() {
    $(this.tree).jstree(true).open_all();
  }

  /**
     * If data really change, reload tree
     *
     * @param {any} nextProps
     * @returns {boolean}
     */
  // shouldComponentUpdate(nextProps) {
  //     if (nextProps.data === this.props.data) {
  //         return false;
  //     }
  //     return true;
  // }

  /**
     * Build search confi
     *
     * @function
     */
  buildSearchConfig() {
    $.jstree.defaults.search.close_opened_onclear = false;
    $.jstree.defaults.search.search_callback = (filterData, node) => {
      const matchCondition =
        this.props.searchOnCondition && this.props.searchOnCondition(filterData, node);
      if (matchCondition) {
        this.closeAll();
        if (DEV_MODE) {
          this.numberMatch++;
          console.log('search_callback_True' + this.numberMatch);
        }
        // if (node.children && node.children.length > 0) {
        //   $(this.tree).jstree('open_node', node);
        // }
        return true;
      }

      return false;
    };
  }

  /**
     * Show contextmenu by left mouse click
     */
  buildContextLeft() {
    $.jstree.plugins.contextmenuleft = function (options, parent) {
      this.bind = function () {
        parent.bind.call(this);
        this.element.on(
          'click.jstree',
          '.jstree-contextmenuleft',
          $.proxy((e) => {
            e.stopImmediatePropagation();
            $(e.target).closest('.jstree-node').children('.jstree-anchor').trigger('contextmenu');
          }, this),
        );
      };

      this.redraw_node = function (obj, deep, callback, force_draw) {
        obj = parent.redraw_node.call(this, obj, deep, callback, force_draw);
        const aTag = obj.getElementsByTagName('a')[0];
        aTag.classList.add('jstree-contextmenuleft');
        return obj;
      };
    };
  }

  /**
     * Show button controls for treen ode
     */
  treeControls() {
    $.jstree.plugins.treeControls = function (options, parent) {
      this.redraw_node = function (obj, deep, callback, force_draw) {
        obj = parent.redraw_node.call(this, obj, deep, callback, force_draw);
        const node = this.get_node($(obj).attr('id'));
        const menu = node.data.menu;
        const iconStyle = node.icon ? '' : 'width: 0px;';
        const dropdown =
          `${`${'<div class="dropdown break-text">' +
            '<div class="dropdown-toggle break-text display-table" id='}${node.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">` +
            '<span class="display-table-cell"><i class="jstree-icon jstree-themeicon jstree-themeicon-custom" role="presentation" style="background-image: url(&quot;'}${node.icon}&quot;); background-position: center center; background-size: auto; ${iconStyle}"></i></span><span>${escapeHtml(node.text)}</span></div>` +
          `<ul class="dropdown-menu" aria-labelledby=${node.id}>` +
          '</ul>' +
          '</div>';
        const a = obj.childNodes[1];
        $(a).html(dropdown);
        const list = [];
        if (menu) {
          const ul = $(a).find('ul');
          for (const item of menu) {
            const li = document.createElement('li');
            const child = document.createElement('a');
            child.href = '#';
            if (item.onClick) {
              child.onclick = item.onClick.bind(this, item.data, node.data, node);
            }
            $(child).html(item.text);
            $(li).append(child);
            $(ul).append(li);
          }
        }
        return obj;
      };
    };
  }

  /**
     * Build Tree config
     *
     * @function
     */
  buildConfigTree(configInfo) {
    const data = configInfo.data;
    const iconType = configInfo.iconType;
    this.buildSearchConfig();
    this.treeControls();
    return {
      core: {
        strings: {
          'Loading ...': 'Please wait ...',
        },
        animation: 50,
        themes: { variant: 'large' },
        data,
        force_text: true,
      },
      types: {
        default: {
          icon: iconType,
        },
      },
      checkbox: {
        three_state: true, // to avoid that fact that checking a node also check others
        real_checkboxes: false,
        whole_node: false, // to avoid checking the box just clicking the node
        tie_selection: false, // for checking without selecting and selecting without checking
      },
      plugins: [
        'search',
        'types',
        // 'contextmenu',
        'treeControls',
        configInfo.checkbox ? 'checkbox' : null,
        configInfo.setState ? 'state' : null,
      ],
    };
  }

  componentDidMount() {
    const treeConfig = this.buildConfigTree(this.props);

    $(this.tree).jstree(treeConfig);

    $(this.tree).bind('ready.jstree', () => this.props.openAll && $(this.tree).jstree('open_all'));

    $(this.tree).on('changed.jstree', (e, data) => {
      this.props.onChange(e, data);
    });
    $(this.tree).on('open_node.jstree', (e, data) => {
      this.props.onOpenNode(e, data);
    });
    $(this.tree).on('close_node.jstree', (e, data) => {
      this.props.onCloseNode(e, data);
    });
    $(this.tree).on('select_node.jstree', (event, selected) => {
      this.props.onSelectNode(event, selected.node);
    });

    $(this.tree).on('check_node.jstree uncheck_node.jstree', (e, data) => {
      this.props.onSelectCheckbox(e, data);
    });

    $(this.tree).on('clear_search.jstree', () => {
      if (this.props.hideLoading) {
        this.props.hideLoading();
      }
    });

    $(this.tree).on('search.jstree', (event, nodes) => {
      const resultList = nodes && nodes.res ? nodes.res : [];
      if (this.props.isSearchOnCondition && this.props.getSearchResult) {
        this.props.getSearchResult(true, nodes.res);
      }
      if (DEV_MODE) {
        console.log('Render Start = ' + this.renderStart);
        const renderEnd = new Date().getTime();
        console.log('Render End = ' + renderEnd);
        const elapsed = renderEnd - this.renderStart;
        console.log('Render time = ' + renderEnd + ' - ' + this.renderStart + ' = ' + elapsed + ' ms');
        console.log('END');
      }
      if (this.props.hideLoading) {
        this.props.hideLoading();
      }
    });

    $(this.tree).on('model.jstree', (node, parent) => {
      // console.log("========================");
      // console.info('model.jstree');
      // console.info(node);
      // console.info(parent);
    });

    $(this.tree).on('close_all.jstree', (e, data) => {
      this.hasBeenClosed = true;
    });

    $(document).on('show.bs.dropdown', (event) => {
      if ($('.dropdown-backdrop') && $('.dropdown-backdrop').length) {
        $('.dropdown-backdrop').off().remove();
      }
    });

    // $(this.tree).on('load_node.jstree', (e, data) => {
    //   if (!this.hasBeenClosed) {
    //     $(this.tree).jstree('open_all');
    //   }
    // });
    const tree = this.tree;
    $(document).on(`${touchStartEvent}.treeEvents`, (e) => {
      if (!$(e.target).hasClass('jstree-anchor')) {
        $('.jstree.jstree-default.jstree-default-large').removeAttr('aria-activedescendant');
      }
    });
    $(document).on(`${touchEndEvent}.treeEvents`, (e) => {
      if (!$(e.target).hasClass('jstree-anchor')) {
        $('.jstree.jstree-default.jstree-default-large').focusout();
        $('.jstree.jstree-default.jstree-default-large').blur();
        $(tree).jstree(true).deselect_all();
      }
    });
    if (supportTouch) {
      $(document).on('mousedown.treeEvents', (e) => {
        if (!$(e.target).hasClass('jstree-anchor')) {
          $('.jstree.jstree-default.jstree-default-large').removeAttr('aria-activedescendant');
        }
      });
      $(document).on('mouseup.treeEvents', (e) => {
        if (!$(e.target).hasClass('jstree-anchor')) {
          $('.jstree.jstree-default.jstree-default-large').focusout();
          $('.jstree.jstree-default.jstree-default-large').blur();
          $(tree).jstree(true).deselect_all();
        }
      });
    }
  }

  componentWillUnmount() {
    $(document).unbind(`${touchStartEvent}.treeEvents`);
    $(document).unbind(`${touchEndEvent}.treeEvents`);
  }

  componentDidUpdate() {
    $(this.tree).jstree(true).settings.core.data = this.props.data;
    if (!this.props.isNotRefresh) {
      $(this.tree).jstree(true).refresh();
    }
  }

  render() {
    return (
      <div className="card padding-10 margin-bottom-132">
        <div
          id={this.props.id}
          ref={(elem) => {
            this.tree = elem;
          }}
        />
      </div>
    );
  }
}

export default TreeView;
